/* eslint-disable jquery/no-find */
/* eslint-disable jquery/no-class */
/* eslint-disable jquery/no-html */
/* eslint-disable jquery/no-attr */
import 'app_storefront_base/productDetail';
import $ from 'jquery';
import Glide from '@glidejs/glide';
import scrollTo from '../util/scrollTo';
import { isLG } from '../util/domutils';

const SELECTORS = {
  NAVIGATORS: {
    ARROWS: '.glide__arrows',
  },
  PRODUCTS: '.product',
};

const CustomLength = function (glide, Components, Events) {
  const addToBagCarouselEvents = {
    handleSlider() {
      if (Components.Sizes.length <= glide.settings.perView) {
        glide.disable();
        Components.Html.root.querySelector(SELECTORS.NAVIGATORS.ARROWS).classList.add('d-none');
      } else {
        glide.enable();
        Components.Html.root.querySelector(SELECTORS.NAVIGATORS.ARROWS).classList.remove('d-none');
      }
    },
    mount() {
      this.handleSlider();
    },
  };
  Events.on('resize', () => {
    addToBagCarouselEvents.handleSlider();
  });
  return addToBagCarouselEvents;
};

const PDPBrandFocusInit = function () {
  if ($('.USPwide').length) {
    const sliders = document.querySelectorAll('.USPwide');
    for (let i = 0; i < sliders.length; i++) {
      const glide = new Glide(sliders[i], {
        type: 'slider',
        startAt: 0,
        bound: true,
        rewind: false,
        gap: 8,
        peek: { before: 0, after: 0 },
        breakpoints: {
          4000: {
            perView: 3,
            peek: { before: 0, after: 110 },
          },
          1279: {
            perView: 2,
            peek: { before: 0, after: 200 },
          },
          1023: {
            perView: 3,
            peek: { before: 0, after: 90 },
          },
          767: {
            perView: 1,
            peek: { before: 0, after: 145 },
          },
        },
      });

      glide.mount({ CustomLength });
    }
  }
};

const closeSizeSelectorDropdown = function () {
  document.addEventListener('click', (event) => {
    const elementsToCheck = document.querySelectorAll(
      // eslint-disable-next-line max-len
      '.select-dropdown__button, .select-dropdown__list, .product-detail button.add-to-cart, .stickyAddToBag, .js-onestock-size-list-item, .onestock-size-selection__list',
    );
    const clickedInside = [...elementsToCheck].some(element => element.contains(event.target));

    if (!clickedInside) {
      document.querySelectorAll('.select-dropdown__button').forEach((button) => {
        button.classList.remove('active');
      });
      document.querySelectorAll('.select-dropdown__list').forEach((list) => {
        list.classList.remove('active');
      });
      if (!isLG()) {
        // eslint-disable-next-line jquery/no-class
        $('body,html').removeClass('overflow-text');
      }
    }
  });
};

$(document).ready(() => {
  let hideTimeout;
  const ctaContainer = document.querySelector('.customer-rating-cta-container');

  function showContainer() {
    if (ctaContainer) {
      ctaContainer.style.display = 'flex'; // Show the container
      setTimeout(() => {
        ctaContainer.style.opacity = '1'; // Fade in effect
      }, 50); // Delay of 50 milliseconds to ensure opacity transition applies
    }
  }

  // Function to handle hiding the container
  function hideContainer() {
    ctaContainer.style.opacity = '0';
    if (ctaContainer) {
      ctaContainer.style.display = 'none';
    }
  }

  // Set a timeout to hide the container after 8 seconds
  function scheduleHide() {
    hideTimeout = setTimeout(() => {
      hideContainer();
      clearTimeout(hideTimeout);
    }, 10000);
  }

  if (ctaContainer) {
    // Set a timeout to show the container after 2 seconds
    setTimeout(showContainer, 2000);
    scheduleHide();
  }

  $('.back-to-tops').click(() => {
    // eslint-disable-next-line jquery/no-animate
    $('html, body').animate({ scrollTop: 0 }, 500);
  });

  document.querySelectorAll('.product-detail button.add-to-cart').forEach((addToBag) => {
    let clickCount = 0;

    addToBag.addEventListener('click', () => {
      clickCount++;

      // Find the nearest product-detail container
      let productDetail = addToBag.closest('.product-detail');
      if (addToBag.closest('.set-item')) {
        productDetail = addToBag.closest('.set-item');
      }
      const closestDropdown = productDetail.querySelector('.product-detail__attribute--size');
      const dropdownList = closestDropdown.querySelector('.select-dropdown__list');
      const selected = closestDropdown.querySelector('.Selected');

      if (!selected) {
        if (clickCount === 1) {
          closestDropdown.classList.add('active');
          dropdownList.classList.add('active');
          if (!isLG()) {
            // eslint-disable-next-line jquery/no-class
            $('body,html').addClass('overflow-text');
          }
        } else if (clickCount === 2) {
          closestDropdown.classList.remove('active');
          dropdownList.classList.remove('active');
          if (!isLG()) {
            // eslint-disable-next-line jquery/no-class
            $('body,html').removeClass('overflow-text');
          }
        }
      }
    });
  });

  const setItems = document.getElementsByClassName('set-items');
  if (setItems.length > 0) {
    $(document).on('click', '.set-shop-outfit', () => {
      scrollTo(setItems[0], true);
    });
  }

  handleProductDescTab();
  document.addEventListener('product:afterAttributeSelect', () => { handleProductDescTab(); });
  closeSizeSelectorDropdown();
  PDPBrandFocusInit();
});

function handleProductDescTab() {
  if ($('.product-desc-desktop').length > 0) {
    const tabLinks = document.querySelectorAll('.bottom-section-header .nav-pills a');

    // Loop through each tab link and update the id and href attributes
    tabLinks.forEach((link) => {
      // Get the current id and href
      const currentId = link.id;
      const currentHref = link.getAttribute('href');

      // Update the id and href
      const newId = `desktop-${currentId}`;
      const newHref = `#desktop-${currentHref.substring(1)}`;

      link.id = newId;
      link.setAttribute('href', newHref);

      // Update the aria-controls attribute
      link.setAttribute('aria-controls', `desktop-${link.getAttribute('aria-controls')}`);
    });

    // Select all the tab content divs
    const bottomSection = document.querySelector('.bottom-section-header');
    const tabContents = bottomSection.querySelectorAll('.tab-content .tab-pane');

    // Loop through each tab content div and update the id
    tabContents.forEach((content) => {
      // Get the current id
      const currentId = content.id;
      // Update the id
      const newId = `desktop-${currentId}`;
      content.id = newId;
    });
  }
}

$(document).on('click', '.style-with-CTA', () => {
  const STYLE_WITH_CONTAINER = '.style_with_product_recs_container';
  scrollTo(STYLE_WITH_CONTAINER, true);
});

$(document).on('click', '.select-dropdown__button', (e) => {
  const $currentDropDown = $(e.currentTarget);
  // eslint-disable-next-line jquery/no-class
  $('.select-dropdown__button').not($currentDropDown).removeClass('active');
  // eslint-disable-next-line jquery/no-class
  $('.select-dropdown__list').not($currentDropDown.next('.select-dropdown__list')).removeClass('active');
  // eslint-disable-next-line jquery/no-class
  $currentDropDown.toggleClass('active');
  // eslint-disable-next-line jquery/no-class
  $currentDropDown.next('.select-dropdown__list').toggleClass('active');

  if (!isLG()) {
    // eslint-disable-next-line jquery/no-class
    if ($currentDropDown.hasClass('active')) {
      // eslint-disable-next-line jquery/no-class
      $('body, html').addClass('overflow-text');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('body, html').removeClass('overflow-text');
    }
  }
});

$(document).on('click', '.header-search', () => {
  // eslint-disable-next-line jquery/no-toggle, jquery/no-class
  $('.search-container').toggleClass('active');
  $('.search-field').focus();
  // eslint-disable-next-line jquery/no-class
  $('.compact-header').toggleClass('bak-Color');
});

$(document).on('click', '.header-element__menu', () => {
  // eslint-disable-next-line jquery/no-class
  $('.compact-header').removeClass('bak-Color');
  // eslint-disable-next-line jquery/no-toggle, jquery/no-class
  $('.search-container').removeClass('active');
});

$(document).on('click', '.select-dropdown__list-item', function () {
  // eslint-disable-next-line jquery/no-class, jquery/no-closest
  $(this).closest('.select-dropdown__list').toggleClass('active');
});

// eslint-disable-next-line max-len
$('.sizeguidelabel .close-icon, #sizeGuideAccordion, .continuity-flyout__close, .js-size-selector-close').on('click', () => {
  // eslint-disable-next-line jquery/no-class
  $('.select-dropdown__list,.select-dropdown__button').removeClass('active');
  // eslint-disable-next-line jquery/no-class
  if (!isLG()) {
    // eslint-disable-next-line jquery/no-class
    $('body ,html').removeClass('overflow-text');
  }
});

$(document).on('click', '.dropdown-swatch', (e) => {
  // eslint-disable-next-line max-len
  const colorSwatchPlaceholder = document.querySelector('.product-detail__stock-check__swatch-label .product-detail__attribute__display-value');
  const swatchDropdown = document.querySelector('.product-detail__stock-check__form__attribute--color');
  const selectedColorValue = e.currentTarget.dataset.value;

  const matchingOption = Array.from(swatchDropdown.options).find(option => option.value === selectedColorValue);

  // eslint-disable-next-line jquery/no-class
  $('.dropdown-swatch').removeClass('attribute_current');
  e.currentTarget.classList.add('attribute_current');
  colorSwatchPlaceholder.innerHTML = e.currentTarget.dataset.tippyContent;

  if (matchingOption) {
    matchingOption.selected = true;
  }
});

$(document).on('click', '.product-detail__stock-check__container  .fit-style', (e) => {
  const fitStyleELE = document.querySelector('.product-detail__stock-check__form__attribute--fitType');
  const selectedFitValue = e.currentTarget.dataset.length;

  const matchingOption = Array.from(fitStyleELE.options).find(option => option.value === selectedFitValue);

  // eslint-disable-next-line jquery/no-class
  $('.product-detail__stock-check__container .fit-style').removeClass('selectedFitVariant');
  e.currentTarget.classList.add('selectedFitVariant');

  if (matchingOption) {
    matchingOption.selected = true;
  }
});

$(document).on('keypress', '.store-postal-code', (event) => {
  if (event.key === 'Enter') {
    event.preventDefault(); // Prevent default form submission
    // eslint-disable-next-line jquery/no-find, jquery/no-closest
    $(event.target).closest('form').find('.btn-storelocator-search').click(); // Submit the form
  }
});

$(document).on('click', '.product-detail__stock-check__result__store-details-toggle', (event) => {
  if (event.target.checked && event.target.classList.contains('stock-body-active')) {
    event.target.checked = false;
    event.target.classList.remove('stock-body-active');
    event.target.previousElementSibling.classList.remove('active');
  } else {
    // eslint-disable-next-line jquery/no-class
    $('.product-detail__stock-check__result__store-details-toggle').removeClass('stock-body-active');
    event.target.classList.add('stock-body-active');
  }
});

const waysToWearComponent = document.querySelector('.waystowear');

if (waysToWearComponent) {
  $(waysToWearComponent).on('slid.bs.carousel', (event) => {
    const activeIndex = [...event.target.querySelectorAll('.carousel-item')].findIndex(
      item => item.classList.contains('active'),
    );
    const subProductsArray = document.querySelectorAll('.waystowear-sub-products');
    const looksTitlesArray = document.querySelectorAll('.waystowear-looks');
    subProductsArray.forEach((item) => {
      item.classList.remove('active');
    });
    looksTitlesArray.forEach((item) => {
      item.classList.remove('active');
    });
    subProductsArray[activeIndex].classList.add('active');
    looksTitlesArray[activeIndex].classList.add('active');
  });
}

document.addEventListener('click', (event) => {
  if (event.target.closest('.carousel-pips')) {
    return;
  }

  const targetElement = event.target.closest('[class*="look-"]');

  if (targetElement) {
    const clickedClass = [...targetElement.classList].find(cls => cls.startsWith('look-'));

    if (clickedClass) {
      document.querySelectorAll('.waystowear .looks').forEach((element) => {
        element.classList.remove('active');
      });

      document.querySelectorAll(`.${clickedClass}`).forEach((element) => {
        element.classList.add('active');
      });
    }
  }
});

// OneStock Delivery Shipping Methods

// eslint-disable-next-line prefer-arrow-callback
$(document).on('submit', '.js-onestock-delivery-option-form', function (e) {
  e.preventDefault();

  const $that = $(this);
  const requestUrl = e.target.getAttribute('action');
  const postalCodeInput = document.querySelector('.js-onestock-postal-code #store-postal-code');
  const callApi = !!postalCodeInput.value;

  let formData = new FormData(e.target);
  formData.append('callApi', callApi);

  formData = new URLSearchParams(formData).toString();

  $that.spinner().start();

  // eslint-disable-next-line jquery/no-ajax
  $.ajax({
    url: requestUrl,
    type: 'GET',
    data: formData,
    success: (data) => {
      if (data) {
        const resultEl = document.querySelector('.js-onestock-delivery-option-result');
        if (resultEl) {
          resultEl.innerHTML = data;
        }

        if (postalCodeInput && !postalCodeInput.hasAttribute('required')) {
          postalCodeInput.setAttribute('required', '');
        }
      }
    },
    complete: () => {
      $that.spinner().stop();
    },
  });
});

const oneStockDeliveryViewMoreOptionEle = document.querySelector('.js-onestock-delivery-option-view-more');

if (oneStockDeliveryViewMoreOptionEle) {
  oneStockDeliveryViewMoreOptionEle.addEventListener('click', () => {
    const resultSection = document.querySelector('.js-onestock-delivery-option-result');

    if (resultSection && resultSection.querySelectorAll('section').length === 0) {
      const form = document.querySelector('.js-onestock-delivery-option-form');

      if (form) {
        const sizeSelectorField = form.querySelector('.js-onestock-size-selector-dropdown');
        if (sizeSelectorField.querySelector('option[value=""]')) {
          sizeSelectorField.selectedIndex = 1;
          sizeSelectorField.dispatchEvent(new Event('change'));
        }
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        $(document).one('ajaxComplete', (e, xhr) => {
          if (xhr.statusText === 'success') {
            sizeSelectorField.selectedIndex = 0;
            sizeSelectorField.dispatchEvent(new Event('change'));
          }
        });
      }
    }
  });
}

$(document).on('click', '.js-onestock-size-list-item', function () {
  // eslint-disable-next-line jquery/no-parents
  const sizeSelect = $(this).parents('.js-onestock-size-selection').find('.js-onestock-selected-size');
  $('.js-onestock-size-list-item').removeClass('selected');
  $(this).addClass('selected');
  const currentSize = $(this).attr('data-size');
  const currentSizeValue = $(this).attr('data-value');

  if (sizeSelect) {
    sizeSelect.html(currentSize);
  }

  // eslint-disable-next-line jquery/no-parents
  const sizeSelection = $(this).parents('.js-onestock-size-selection').prev().find('select option');
  // eslint-disable-next-line jquery/no-parents
  const sizeOption = $(this).parents('.js-onestock-size-selection').prev().find('select');

  sizeSelection.filter(function () {
    // eslint-disable-next-line jquery/no-text, jquery/no-val
    return $(this).val() === currentSizeValue;
  }).prop('selected', true).trigger('change');

  sizeOption.removeClass('is-invalid');

  $('.js-size-selection-container').removeClass('active');
});
